import React, { createContext, useContext, useState, useEffect } from "react";
import { GetToolSubscription } from "../../services/backendServices";
import { UseConfigContext } from "./ConfigContext";
import { UseProfileContext } from "./ProfileContext";
import { checkBrokerPanelUser } from "../../Util/helper_functions";
// Create a context for ToolSubscriptionData 
const ToolSubscriptionContext = createContext();
/*** ToolSubscriptionContext: A provider component to manage and supply subscription data*/
export const ToolSubscriptionContextProvider = ({ children }) => {
    const [toolSubscriptionData, setToolSubscriptionData] = useState(null);
    const { configData } = UseConfigContext();
    const { profileData } = UseProfileContext();
    const hasSubscribed = configData?.is_tool_free === true || profileData?.has_tools_subscription === true;

    // Function for fetch subscription Data 
    const fetchToolSubscriptionData = async () => {
        try {
            const res = await GetToolSubscription();
            if (res.status) {
                setToolSubscriptionData(res.data);
            }
        } catch (e) {
            console.log("Error fetching tool subscription data:", e);
        } finally {
        }
    };

    // Check subscription status and fetch data
    useEffect(() => {
        if (hasSubscribed && checkBrokerPanelUser()) {
            fetchToolSubscriptionData();
        }
    }, [hasSubscribed]);
    return (
        // The ProfileContext.Provider component provides state and functions to the children components
        <ToolSubscriptionContext.Provider
            value={{
                fetchToolSubscriptionData, toolSubscriptionData, setToolSubscriptionData
            }}>
            {children}
        </ToolSubscriptionContext.Provider>
    );
};

// Custom hook to use the UserProfileContext
export const useToolSubscriptionContext = () => useContext(ToolSubscriptionContext);
